import React, {Component} from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Header from "../header";
import Footer from "../footer";
import * as images from '../assets/img';

class TabsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slideIndex: 0,
            isOpen: false,
            photoIndex: 0,
        };
    }

    handleChange = (value) => {
        this.setState({
            slideIndex: value,
        });
    };

    handleClick(image) {
        this.setState({
            isOpen: true,
            image: image
        });
    }


    render() {
        return (
            <div>
                <Header />
                <main className="tabsPage index">
                    <div className="container">
                        <div className="main-container">

                            <div className="boxes box-left" style={{ marginTop: 50 }}>
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('bella_plus')}>
                                        <img src={images.bella_plus} alt="Bella Plus"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Bella Plus </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Bella </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('bella')}>
                                        <img src={images.bella} alt="Bella Plus"/>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('camel')}>
                                        <img src={images.camel} alt="Camel"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Camel </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Elegance </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('elegance')}>
                                        <img src={images.elegance} alt="Elegance" />
                                    </div>
                                </div>
                            </div>


                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('elizabeth')}>
                                        <img src={images.elizabeth} alt="elizabeth"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Elizabeth </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Emily </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('emily')}>
                                        <img src={images.emily} alt="Emily" />
                                    </div>
                                </div>
                            </div>


                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('even')}>
                                        <img src={images.even} alt="Even"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Even </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Flora </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('flora')}>
                                        <img src={images.flora} alt="Flora" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('fotokapak')}>
                                        <img src={images.fotokapak} alt="Foto Kapak"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Foto Kapak </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Leinen </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('leinen')}>
                                        <img src={images.leinen} alt="Leinen" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('lima')}>
                                        <img src={images.lima} alt="Lima"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Lima </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Liva </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('liva')}>
                                        <img src={images.liva} alt="Liva" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('lowra')}>
                                        <img src={images.lowra} alt="Lowra"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Lowra </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Luna Plus</strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('luna_plus')}>
                                        <img src={images.luna_plus} alt="Luna Plus" />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('luna')}>
                                        <img src={images.luna} alt="Luna"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Luna </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Magneto </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('magneto')}>
                                        <img src={images.magneto} alt="Megneto" />
                                    </div>
                                </div>
                            </div>

                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('marvel')}>
                                        <img src={images.marvel} alt="Marvel"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Marvel </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Medusa </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('medusa')}>
                                        <img src={images.medusa} alt="Medusa" />
                                    </div>
                                </div>
                            </div>

                                                                                    
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('montana')}>
                                        <img src={images.montana} alt="Montana"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Montana </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Nubuk </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('nubuk')}>
                                        <img src={images.nubuk} alt="Nubuk" />
                                    </div>
                                </div>
                            </div>

                                                                                                                
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('rachel')}>
                                        <img src={images.rachel} alt="Rachel"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Rachel </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Reina </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('reina')}>
                                        <img src={images.reina} alt="Reina" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                            
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('ruby')}>
                                        <img src={images.ruby} alt="Ruby"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Ruby </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Saha </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('saha')}>
                                        <img src={images.saha} alt="Saha" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                            
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('september')}>
                                        <img src={images.september} alt="September"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> September </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Sieana </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('sieana')}>
                                        <img src={images.sieana} alt="Sieana" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('square')}>
                                        <img src={images.square} alt="Square"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Square </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Straw </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('straw')}>
                                        <img src={images.straw} alt="Straw" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('tokyo')}>
                                        <img src={images.tokyo} alt="Tokyo"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Tokyo </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Velvet </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('velvet')}>
                                        <img src={images.velvet} alt="Velvet" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('window_plus')}>
                                        <img src={images.window_plus} alt="Window Plus"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Window Plus </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Window </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('window')}>
                                        <img src={images.window} alt="Window" />
                                    </div>
                                </div>
                            </div>

                                                                                                                                                                        
                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('wood_plus')}>
                                        <img src={images.wood_plus} alt="Wood Plus"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Wood Plus </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Wood </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('wood')}>
                                        <img src={images.wood} alt="Wood" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box" onClick={() => this.handleClick('root')}>
                                        <img src={images.root} alt="Root"/>
                                    </div>

                                    <div className="description-box">
                                        <strong> Root </strong>
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-right">
                                <div className="boxes-container">
                                    <div className="description-box">
                                        <strong> Simple </strong>
                                    </div>

                                    <div className="picture-box" onClick={() => this.handleClick('simple')}>
                                        <img src={images.simple} alt="Simple" />
                                    </div>
                                </div>
                            </div>

                            <div className="boxes box-left">
                                <div className="boxes-container">
                                    <div className="picture-box sandık">
                                        <img src={images.sandik_1} onClick={() => this.handleClick('sandik_1')} alt="Sandık 1" style={{ marginBottom: 75, maxHeight: 400, width: 'auto' }} />
                                        <img src={images.sandik_2} onClick={() => this.handleClick('sandik_2')} alt="Sandık 2" />
                                    </div>

                                    <div className="description-box">
                                        <strong> Sandık </strong>
                                    </div>
                                </div>
                            </div>

                            {this.state.isOpen && (
                                <Lightbox
                                    mainSrc={images[this.state.image]}
                                    onCloseRequest={() => this.setState({ isOpen: false })}
                                />
                            )}

                        </div>
                    </div>

                </main>
                <Footer/>
            </div>
        );
    }
}

export default TabsPage;